import styled, { css } from 'styled-components';
import { transparentize } from 'utils/color';
import media from 'components/mixins/media';
import { reviewFontText } from 'components/mixins/reviewTypography';
import { transition } from 'components/mixins/interactivity';
import Icon from 'components/common/Icon';

export const CommentIcon = styled(Icon)`
  color: inherit;
  margin: 0;

  &.icon {
    line-height: 13px;
  }
`;

export const ToggleButtonText = styled.span`
  display: inline-block;
  opacity: 0;
  ${transition('all', '0.3s')};
`;

type ToggleButtonProps = {
  isGeneral: boolean;
  isActive: boolean;
};
export const ToggleButton = styled.div<ToggleButtonProps>`
  ${reviewFontText};
  cursor: pointer;
  font-size: 12px;
  font-weight: 600;
  margin: 10px;
  overflow: hidden;
  ${props =>
    props.isGeneral
      ? css`
          padding: 14px 39px 14px 0;
          color: ${transparentize('#42515f', 0.5)};
          background: #fff;
          border-radius: 22px;
          box-shadow: 0 2px 10px 0 ${transparentize('#000000', 0.1)};

          height: 41px;
          ${transition('all', '0.3s')};

          &:hover {
            max-width: 100%;
          }

          &:hover,
          &:focus {
            color: #4caf50;
            outline: none;

            ${CommentIcon} {
              color: #4caf50;
            }
          }

          ${CommentIcon} {
            color: #73899e;
            margin: 0 21px 0 15px;
            transform: scale(1.4);
            display: inline-block;
            ${transition('all', '0.3s')};
          }

          ${props.isActive &&
            css`
              color: #4caf50;
              box-shadow: inset 0 1px 3px 0 ${transparentize('#000000', 0.08)};

              ${CommentIcon} {
                color: #4caf50;
              }
            `}
        `
      : css`
          width: 34px;
          height: 34px;
          display: flex;
          justify-content: center;
          align-items: center;
          color: #73899e;
          background: #fff;
          margin: 6px;
          padding: 10px;
          border-radius: 50%;
          box-shadow: 0 2px 10px 0 ${transparentize('#000000', 0.1)};

          &:hover,
          &:focus {
            color: #4caf50;
            outline: none;
          }

          ${props.isActive &&
            css`
              background: #4caf50;
              color: #fff;

              &:hover,
              &:focus {
                color: #fff;
                outline: none;
              }
            `}
        `};
`;

type ReviewWrapperProps = {
  isVoiceOver: boolean;
  isGeneral: boolean;
  isActive: boolean;
};
export const ReviewWrapper = styled.div<ReviewWrapperProps>`
  background: ${transparentize('#191919', 0.02)};

  & .active {
    display: block !important;
  }

  ${props =>
    props.isVoiceOver &&
    css`
      ${media.small`
        display: none;
      `};
    `}

  ${props =>
    props.isGeneral
      ? css`
          position: fixed;
          bottom: 8px;
          right: 24px;
          z-index: 101;

          max-width: 61px;
          white-space: nowrap;
          ${transition('all', '0.3s')};

          ${props.isActive &&
            css`
              max-width: 300px;

              ${ToggleButtonText} {
                opacity: 1;
              }

              ${ToggleButton} {
                ${CommentIcon} {
                  margin: 0 21px 0 24px;
                  transform: scale(1);
                }
              }
            `}

          &:hover {
            max-width: 300px;

            ${ToggleButtonText} {
              opacity: 1;
            }
            ${CommentIcon} {
              color: #73899e;
              margin: 0 21px 0 24px;
              transform: scale(1);
            }
          }
        `
      : css`
          position: absolute;
          top: 0;
          right: -52px;
          z-index: 10;
          display: flex;
          ${media.large`
            right: -22px;
          `}
        `}
  border-radius: 30px;
`;
